import { inject, Injectable } from "@angular/core";
import { Auth } from "../services/auth";
import { HttpEvent, HttpHandler, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable()
export class HttpInterceptor implements HttpInterceptor{
    private authService = inject(Auth)
    user:any;
    constructor(){
        this.authService.user.subscribe((x:any)=>this.user = x);
    }

    intercept(request:HttpRequest<any>, next:HttpHandler):Observable<HttpEvent<any>>{
        const isLoggedIn = this.user?.jwtToken;
        const isApiUrl = request.url.startsWith(environment.apiUrl);
        if(isLoggedIn && isApiUrl){
            request = request.clone({
                setHeaders:{Authorization: `Bearer ${this.user?.jwtToken}`,
                   

            }
            });
        }
        return next.handle(request);
    }
}